import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../shared/material.module';
import { AddPyramidalPyramidItemComponent } from '../add-pyramidal-pyramid-item/add-pyramidal-pyramid-item.component';
import { AddPyramidalPyramidSearchConnectComponent } from '../add-pyramidal-pyramid-search-connect/add-pyramidal-pyramid-search-connect.component';

export interface AddPyramidalPyramidDialogData {
  pyramidalShareholderId: string;
}

type DialogMode = 'add-new' | 'search-connect';

@Component({
  selector: 'app-add-pyramidal-pyramid-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MaterialModule,
    AddPyramidalPyramidItemComponent,
    AddPyramidalPyramidSearchConnectComponent
  ],
  templateUrl: './add-pyramidal-pyramid-dialog.component.html',
  styleUrls: ['./add-pyramidal-pyramid-dialog.component.scss']
})
export class AddPyramidalPyramidDialogComponent implements OnInit {
  @ViewChild(AddPyramidalPyramidItemComponent) addPyramidItemComponent!: AddPyramidalPyramidItemComponent;
  @ViewChild(AddPyramidalPyramidSearchConnectComponent) addPyramidSearchConnectComponent!: AddPyramidalPyramidSearchConnectComponent;

  currentMode: DialogMode = 'search-connect';
  isAddNewItemFormValid: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddPyramidalPyramidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddPyramidalPyramidDialogData
  ) {
  }

  ngOnInit(): void {}

  onAddNewFromSearch(): void {
    this.currentMode = 'add-new';
    this.isAddNewItemFormValid = false;
  }

  onBack(): void {
    this.currentMode = 'search-connect';
    this.isAddNewItemFormValid = false;
  }

  onConfirm(): void {
    if (this.currentMode === 'add-new') {
      this.addPyramidItemComponent.onConfirm();
    } else if (this.currentMode === 'search-connect') {
      this.addPyramidSearchConnectComponent.addPyramidItemComponent.onConfirm();
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  getDialogTitle(): string {
    switch (this.currentMode) {
      case 'add-new':
        return 'Add New Pyramidal Shareholder';
      case 'search-connect':
        return 'Add New Pyramid Item';
      default:
        return 'Add New Pyramid Item';
    }
  }

  onFormValidityChange(isValid: boolean) {
    this.isAddNewItemFormValid = isValid;
  }

}
